import { useState } from 'react';
import { Button, TextField, Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import { message } from 'antd';

export default function Filter({process,setDateStartFilter, setDateEndFilter,setIdOrderFilter,setClientFilter,setColorFilter,setProcessFilter,filterOrders,cleanFilterOrders}) {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  const toggleAccordion = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };

  return (
    <div style={{ flexDirection: 'column'}}>
      <Button
        style={{ marginBottom: '15px' }}
        variant="contained"
        size="small"
        onClick={toggleAccordion}
      >
        {isAccordionOpen ? 'Cerrar Filtros' : 'Abrir Filtros'}
      </Button>

      {isAccordionOpen && (
        <div style={{ display: 'flex', flexDirection: 'row' , marginBottom:'10px' }}>
          <TextField
            style={{ marginRight: '15px' }}
            label="Fecha de pedido"
            onChange={(e) => {
              setDateStartFilter(e.target.value);
            }}
            type="date"
            id="dateStart"
            InputLabelProps={{
              shrink: true,
            }}
          />
          
          <TextField
            style={{ marginRight: '15px' }}
            label="Fecha de entrega"
            onChange={(e) => {
              setDateEndFilter(e.target.value);
            }}
            type="date"
            id="dateStart"
            InputLabelProps={{
              shrink: true,
            }}
          />


          <TextField
              style={{ marginRight: '15px'}}
              label="Numero de orden"
              onChange={(e)=>{
                setIdOrderFilter(e.target.value);
              }}
              type="text"
              id="idOrder"
              InputLabelProps={{
                  shrink: true,
              }}
          />
          <TextField
              style={{ marginRight: '15px'}}
              label="Cliente"
              onChange={(e)=>{
                setClientFilter(e.target.value);
              }}
              type="text"
              id="clientOrder"
              InputLabelProps={{
                  shrink: true,
              }}
          />
          <TextField
              style={{ marginRight: '15px'}}
              label="Color"
              onChange={(e)=>{
                setColorFilter(e.target.value);
              }}
              type="text"
              id="colorOrder"
              InputLabelProps={{
                  shrink: true,
              }}
          />

          <FormControl >
              <InputLabel id="select_productPrice">Proceso</InputLabel>
              <Select
                  labelId='select_productPrice'
                  native
                  label='Proceso'
                  inputProps={{
                      name: 'productPrice',
                      id: 'productPrice',
                  }}
                  onChange={(e)=>{
                    setProcessFilter(e.target.value);
                }}
              >
                  {process ? (
                      <>
                          <option key={'false'} value={false}>
                              {'Seleccione'}
                          </option>
                          {process.map((p) => (
                              <option key={p.cod} value={p.cod}>
                                  {p.name === 'DEFECTO' ? 'SIN PROCESO' : p.name}
                              </option>
                          ))}
                      </>
                  ) : null}
              </Select>
          </FormControl>


          <Button
            style={{ marginLeft: '15px', marginBottom: '10px' }}
            variant="contained"
            size="small"
            onClick={() => {
              try {
                filterOrders()
              } catch (error) {
                message.error(error.message);
              }
            }}
          >
            Filtrar
          </Button>
          <Button
            style={{ marginLeft: '15px', marginBottom: '10px' }}
            variant="contained"
            size="small"
            onClick={() => {
             cleanFilterOrders()
            }}
          >
            Limpiar filtro
          </Button>
        </div>
      )}
    </div>
  );
}
